import api from "@/services/api";
import { ENDPOINTS_TRANSACTIONS } from "@/services/endpoints";

export const listTransactions = () => api.get(ENDPOINTS_TRANSACTIONS.list).then((r) => r.data);
